<template lang="pug">
	article#home
		Banners
		CategoriaCursos
		Unidades
		BlogFael
		//- Depoimentos
</template>

<script>
import Banners from '@sections/Home/Banners/Banners.vue'
import CategoriaCursos from '@sections/Home/CategoriaCursos/CategoriaCursos.vue'
import Unidades from '@sections/Home/Unidades/Unidades.vue'
import BlogFael from '@components/BlogFael/BlogFael.vue'
// import Depoimentos from '@sections/Home/Depoimentos/Depoimentos.vue'

export default {
	name: "view-home",
	components: {
		Banners,
		CategoriaCursos,
		Unidades,
		BlogFael,
		// Depoimentos,
	}
}
</script>

<style lang="stylus" scoped src="@views/Home/Home.styl"></style>
